import { FC } from 'react';
import { SecondaryButtonProps } from './types';

const SecondaryButton: FC<SecondaryButtonProps> = (props) => {
	let baseWidthClass = 'pop-w-[75%]'; // default

  if (props.fullButtonSecondary) {
    baseWidthClass = 'pop-w-full';
  } else if (props.halfButtonSecondary) {
    baseWidthClass = 'pop-w-[50%]';
  }

  const shadowClass = props.shadow === 'none' ? '' : 'pop-shadow-lg';
  
  // Font size logic
  let fontSizeClass = 'pop-text-sm'; // default
  if (props.fontSize === 'small') {
    fontSizeClass = 'pop-text-xs';
  } else if (props.fontSize === 'large') {
    fontSizeClass = 'pop-text-lg';
  }

	return (
    <button
      className={`
        pop-btn2 ${shadowClass} ${fontSizeClass}
        ${props.isDisabled
          ? `disabled:pop-bg-popsizeNeutral10 disabled:pop-text-popsizeNeutral20 pop-border-none ${baseWidthClass}`
          : `${baseWidthClass} pop-border-none
             hover:pop-bg-popsizeSecondary20 hover:pop-border-popsizeSecondary90 
             ${props.className ? props.className : ''}`
        }
      `}
      onClick={props.onClick}
      disabled={props.isDisabled}
    >
      {props.isLoading ? (
        <span className="pop-loading pop-loading-dots pop-loading-md"></span>
      ) : (
        props.children
      )}
    </button>
  );
};

export default SecondaryButton;
